export * from './authentication.service';
export * from './declaration.service';
export * from './employee.service';
export * from './navigation.service';
export * from './document-type.service';
export * from './company.service';
export * from './group-company.service';
export * from './salary-area.service';
export * from './payment-method.service';
export * from './city.service';
export * from './district.service';
export * from './wards.service';
export * from './isurrance-department.service';
export * from './nationality.service';
export * from './hospital.service';
export * from './people.service';
export * from './plan.service';
export * from './payment-status.service';
export * from './relationship.service';
export * from './bank.service';
export * from './department.service';
export * from './village.service';
export * from './document-list.service';
export * from './declaration-file.service';
export * from './sicknesses.service';
export * from './category.service';
export * from './file-upload.service';
export * from './navigation.service';
export * from './agencie.service';
export * from './customer.service';
export * from './staff.service';
export * from './product.service';
export * from './account.service';
export * from './role.service';
export * from './email-notification.service';
export * from './contract.service';
export * from './price.service';
export * from './switch-vendor.service';
export * from './external.service';
export * from './submit-declaration.service';
export * from './declaration-file-upload.service';
export * from './coefficient.service';
export * from './benefit-level.service';
export * from './declaration-config.service';
export * from './app-config.service';
export * from './group-benefit-level.service';
export * from './hub.service';
export * from './software-vendor.service';
export * from './license.service';
export * from './insurance-code-state.service';